export const actionLogActionTypes = {
    STORE_CUSTOMER_ACTIONLOGS: "STORE_CUSTOMER_ACTIONLOGS",
    STORE_MY_ACIONLOGS: "STORE_MY_ACIONLOGS",
    "STORE_SYSTEM_ACTIONLOGS": "STORE_SYSTEM_ACTIONLOGS",
}